import React from 'react'
import Navbar from './Navbar'

const Referals = () => {
  return (
    <>
    <Navbar/>
    <div>
       Referal  Page Comming Soon....
    </div>
    </>
  )
}

export default Referals
